export function requestElementFullscreen(el) {
  if (!el) return Promise.reject(new Error('no element'));
  const fn =
    el.requestFullscreen ||
    el.webkitRequestFullscreen ||
    el.mozRequestFullScreen ||
    el.msRequestFullscreen;
  if (!fn) return Promise.reject(new Error('fullscreen unsupported'));
  return Promise.resolve(fn.call(el));
}

export function exitFullscreen() {
  const fn =
    document.exitFullscreen ||
    document.webkitExitFullscreen ||
    document.mozCancelFullScreen ||
    document.msExitFullscreen;
  if (fn) return Promise.resolve(fn.call(document));
  return Promise.resolve();
}

export function isFullscreenActive() {
  return !!(
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement
  );
}

export function shouldAutoFullscreen() {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('fs') === '1';
}
